import * as React from 'react';

import {useAppSelector} from "../../app/hooks";
import {selectCounter, selectSleepPeriod, selectStatus, selectWorkoutPeriod} from "../yoga/yogaSlice";
import ReactPlayer from 'react-player/lazy'
import styles from './BackgroupPlayer.module.css';

export function StatePlayer() {
    const status = useAppSelector(selectStatus);
    const counter = useAppSelector(selectCounter);
    const sleepPeriod = useAppSelector(selectSleepPeriod);
    const workoutPeriod = useAppSelector(selectWorkoutPeriod);
    const totalPeriod = sleepPeriod + workoutPeriod
    const periodTime = counter % totalPeriod
    const isWorkoutPeriod = periodTime < workoutPeriod
    const playing = (status === 'workout') && (((counter / totalPeriod) >= 1) || (counter > 60))
    return (
        <div className={styles.player}>
                <ReactPlayer
                    playing = {playing && isWorkoutPeriod}
                    loop
                    url={[{src: 'start.mp3', type: 'audio/mp3'}]}/>
                <ReactPlayer
                    playing = {playing && !isWorkoutPeriod}
                    url={[{src: 'end.mp3', type: 'audio/mp3'}]}/>)
        </div>
    )
}